export default __webpack_public_path__ + "static/media/39-Receiving-Award.d5d8f57d.jpeg";